import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { useAuthStore } from '@/stores/authStore'

export interface UserStats {
  totalVideos: number
  thisMonthVideos: number
}

export interface MenuHiddenFlags {
  community: boolean
}

export interface AuthMeResponse {
  id: string
  email: string
  source: 'gov' | 'wrks'
  isAdmin: boolean
  hasUsage: boolean
  /** 테넌트 문서보안(DRM) 활성 여부 — 업로드/다운로드가 웍스 DRM API 를 경유한다 */
  isDrmActive: boolean
  enterpriseId: number | null
  workspaceId: number | null
  menuHidden: MenuHiddenFlags
  stats: UserStats
}

export function useAuthMe() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => api.get<AuthMeResponse>('/auth/me'),
    enabled: isAuthenticated,
    staleTime: 1000 * 60,
  })
}

export function useInvalidateAuthMe() {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: ['auth', 'me'] })
}
